<template>

  <section>

    <div style="height: 10px;">&nbsp;</div>

    <div class="img">
      <!-- <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">商务出行专属优惠：</div> -->
      <div>
        <img src="../assets/aomenappointment.jpg" style="width: 100%;height: 180px;" />
      </div>
    </div>

    <div style="width: 96%;margin: 0 2% 10px;text-align: center;font-size: 20px;color:  #2754BB;">政企商务机票预约下单</div>
    <div class="demand">
      <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">预约信息填写：</div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的称呼：(必填)</div>
        <Input v-model="name" clearable placeholder=""/>
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的联系电话：(必填)</div>
        <Input v-model="phone" type="tel" clearable placeholder=""/>
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>联系单位：(必填)</div>
        <Input v-model="address" clearable placeholder=""/>
      </div>
      <div>
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的需求：(必填)</div>
        <Input v-model="demand" clearable type="textarea" :autosize="{minRows: 4,maxRows: 4}" placeholder="请输入您的需求:日期﹑行程﹑时间﹑人数等。" />
      </div>
    </div>

    <button class="appointment" v-on:click="appointment()" style="display: block;">预约</button>

    <div style="width: 96%;margin: 0 2%;text-align: center;">中山候机楼丨0760-88880777 / 18029902235</div>

  </section>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import addressApi from '../request/addressApi';
  import axios from 'axios';
  export default {
    name: 'aomenshopAppointment',
    data() {
      return {
        demand:'',
        name:'',
        phone:'',
        address:'',
      };
    },
    components: {},
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      flightApi.saveSearchFlightRecord(this.$store.state.user.OpenId, baseTool.formatterDate(new Date()),'政企商务机票预约').then(sucRes => {});
      this.getUserAddress();
    },
    activated() {},
    methods: {
      getUserAddress() {
        // 获取地址列表
        addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
          if (sucRes.success && sucRes.data.length > 0) {
            sucRes.data.forEach(item => {
              if (item.IsDefault == true) {
                this.name = item.Contact;
                this.phone = item.Mobile;
              }
            });
          }
        });
      },
      appointment() {
        var that = this;

        if (this.name == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的称呼不能为空'
          });
          return;
        }
        if (this.phone == '' || this.phone.length < 8 || this.phone.length > 11 || this.phone.length == 9 || this.phone.length == 10) {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的联系电话不能为空或者电话号码长度不正确'
          });
          return;
        }
        if (this.address == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '联系单位不能为空'
          });
          return;
        }
        if (this.demand == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的需求不能为空'
          });
          return;
        }
        console.log(this.$store.state.user.OpenId, this.name, this.phone, this.demand, this.address);
        flightApi.appointmentFlight(
            this.$store.state.user.OpenId,
            '政企商务机票预约',
            this.name,
            this.phone,
            '政企商务机票预约:' + '联系单位:' + this.address +'需求:' + this.demand,
            null,
            null,
          )
          .then(sucRes => {
            this.demand = '';
            this.name = '';
            this.phone = '';
            this.address = '';
            if (sucRes.success == true) {
              this.$Modal.success({
                title: '恭喜你!',
                content: sucRes.message
              });
            } else {
              this.$Modal.error({
                title: '很遗憾!',
                content: sucRes.message
              });
            }
          });
      },
    },
  };
</script>

<style>

  .img{
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
  }

  .demand{
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
  }

  .infomation{
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
  }

  .appointment {
    width: 94%;
    margin: 10px 3% 0 3%;
    background: #2754bb;
    color: white;
    height: 40px;
    font-size: 18px;
    border: 0;
    border-radius: 10px;
    line-height: 10px;
    /* margin-bottom: 10px; */
  }

  input::-webkit-input-placeholder {
    color: #515A6E;
  }

  input::-moz-input-placeholder {
    color: #515A6E;
  }

  input::-ms-input-placeholder {
    color: #515A6E;
  }

  .top_recognition {
    /* margin: 0 0 10px 0; */
  }

  .recognition {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/aomenshopAppointment.vue